<template>
  <!-- middle -->
  <div class="about-inner sort-inner py-5" style="padding-bottom: 0 !important">
    <div class="container pb-xl-5 pb-lg-3 container1500">
      <h3 class="tittle text-center font-weight-bold">{{ $t('index.fourth.title') }}</h3>
      <div class="sort_list">
        <div
          v-for="(item, index) in sortList"
          :key="index"
          :class="sortIndex == index ? 'sort_active sort_item' : 'sort_item'"
          @click="onSortClick(index)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="row py-xl-4">
        <div v-for="(item, index) in indexNews" :key="index" class="inner_item">
          <div class="inner_item_left">
            <div class="inner_item_left_top">
              {{ formatDate(item.releaseTime).day }}
            </div>
            <div class="inner_item_left_bottom">
              {{ formatDate(item.releaseTime).year }}
            </div>
          </div>
          <div class="inner_item_right" @click="openPage('b', item.website)">
            <div class="inner_item_right_top">{{ item.title }}</div>
            <div class="inner_item_right_bottom">{{ item.digest }}</div>
          </div>
        </div>
        <div v-if="indexNews.length == 0" class="sort_item">{{ $t('index.fourth.noData') }}</div>
      </div>
      <div class="inner_more" v-if="indexNews.length > 0">
        <a href="#" class="btn button-style mt-4">{{ $t('index.fourth.btnText') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexNewsList } from "@/api/index/index";
export default {
  data() {
    return {
      sortIndex: 0,
      sortList: [
        { label: this.$t('index.fourth.tab1'), value: "1" },
        { label: this.$t('index.fourth.tab2'), value: "2" },
        { label: this.$t('index.fourth.tab3'), value: "3" },
        { label: this.$t('index.fourth.tab4'), value: "4" },
      ],
      indexNews: [],
    };
  },
  mounted() {
    this.getIndexNews();
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      const yearMonth = `${year}-${month}`;
      return { year: yearMonth, day: day };
    },
    getIndexNews() {
      getIndexNewsList(this.sortIndex).then((res) => {
        this.indexNews = res.data.records;
      });
    },
    onSortClick(index) {
      this.sortIndex = index;
      this.getIndexNews();
    },

    openPage(type, url){
      if(type === 'b'){
        window.open(url,'_blank');
      }
    }
  },
};
</script>

<style lang="scss" scoped></style>
